/**
 * @file 关注bar组件
 * @author yanyiting@baidu.com
 * */

import {Component} from 'san';
import HugConfirm from '@components/hug-confirm';
import './index.scss';


export default class AttentionBar extends Component {
    static components = {
        'components-hug-confirm': HugConfirm
    };

    static template = `
        <div class="attention-bar-wrap">
            <div class="avatar"
                style="background: url({{avatar}}) center / cover no-repeat"
                on-click="attentionClick"></div>
            <div class="info">
                <div class="name">{{name}}</div>
                <div class="intro" s-if="brief">{{brief}}</div>
            </div>
            <div s-if="reflow" class="attetion-btn" on-click="attentionClick"></div>
            <components-hug-confirm
                value="{= invokeModalVisible =}"
                cancelText="不感兴趣"
                confirmText="去APP"
                on-confirm="invokeAppConfirm">
                获取更多作者独家分享!
            </components-hug-confirm>
        </div>
    `;

    initData() {
        return {
            invokeModalVisible: false
        };
    }

    // 关注按钮点击
    attentionClick() {
        if (!this.data.get('reflow')) {
            return;
        }
        this.data.set('invokeModalVisible', true);
        this.fire('attentionClick');
    }
    // 弹窗确认
    invokeAppConfirm() {
        this.fire('confirm-click');
    }
}
